/* TROPICO cart drawer: one-click add from suggestions and the empty state */
(function () {
  'use strict';
  if (window.__tpcCartBound) return;
  window.__tpcCartBound = true;

  // Keep the drawer above the sticky buy bar, and hide that bar while the drawer is open.
  (function () {
    var st = document.createElement('style');
    st.textContent = 'cart-drawer.drawer{z-index:2147483000}body:has(cart-drawer.active) .kyro-sticky,body.tpc-drawer-open .kyro-sticky{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  })();

  // Checkout: go straight to checkout, independent of the form wiring.
  // Capture phase so no other handler can swallow the click.
  var tpcGoing = false;
  function tpcCheckout(e) {
    var btn = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout, #CartDrawer .cart__checkout-button');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (tpcGoing) return;
    tpcGoing = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');
    window.location.assign(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout');
    setTimeout(function () { tpcGoing = false; btn.classList.remove('loading'); btn.removeAttribute('aria-busy'); }, 6000);
  }
  document.addEventListener('click', tpcCheckout, true);

  // Self-heal the drawer: keep the "is-empty" state in line with what is rendered,
  // and re-render from the server when the markup is stale.
  var tpcRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var tpcBusy = false;
  function tpcDrawer() { return document.querySelector('cart-drawer'); }
  function tpcRefresh() {
    var d = tpcDrawer();
    if (!d || tpcBusy) return Promise.resolve();
    tpcBusy = true;
    return fetch(tpcRoot + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var freshDrawer = doc.querySelector('cart-drawer');
        var cur = document.getElementById('CartDrawer');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          var empty = freshDrawer ? freshDrawer.classList.contains('is-empty') : !cur.querySelector('.cart-item');
          d.classList.toggle('is-empty', empty);
          var ov = cur.querySelector('#CartDrawer-Overlay');
          if (ov) ov.addEventListener('click', function () { d.close(); });
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var src = bdoc.querySelector('.shopify-section');
          if (src) bubble.innerHTML = src.innerHTML;
        }
      })
      .catch(function (err) { console.error('TROPICO cart refresh failed', err); })
      .then(function () { tpcBusy = false; });
  }
  function tpcSync() {
    var d = tpcDrawer();
    if (!d || tpcBusy) return;
    var hasItems = !!d.querySelector('#CartDrawer .cart-item');
    var hasEmpty = !!d.querySelector('#CartDrawer .drawer__inner-empty');
    var items = d.querySelector('cart-drawer-items');
    if (hasItems) {
      if (d.classList.contains('is-empty')) d.classList.remove('is-empty');
      if (items && items.classList.contains('is-empty')) items.classList.remove('is-empty');
    } else if (hasEmpty) {
      if (!d.classList.contains('is-empty')) d.classList.add('is-empty');
    } else if (!d.querySelector('.loading__spinner:not(.hidden)')) {
      tpcRefresh();
    }
  }
  var tpcSyncTimer;
  function tpcSyncSoon() { clearTimeout(tpcSyncTimer); tpcSyncTimer = setTimeout(tpcSync, 150); }
  function tpcWatch() {
    var d = tpcDrawer();
    if (!d || d.__tpcWatched) return;
    d.__tpcWatched = true;
    new MutationObserver(tpcSyncSoon).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    // Hide the sticky buy bar while the drawer is open so it can't cover the checkout button.
    var tpcOpenState = function () { document.body.classList.toggle('tpc-drawer-open', d.classList.contains('active')); };
    new MutationObserver(tpcOpenState).observe(d, { attributes: true, attributeFilter: ['class'] });
    tpcOpenState();
    // Every time the drawer opens, make sure it shows the real cart.
    var origOpen = d.open;
    if (typeof origOpen === 'function') {
      d.open = function () {
        var args = arguments, self = this;
        origOpen.apply(self, args);
        fetch(tpcRoot + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var rows = self.querySelectorAll('#CartDrawer .cart-item').length;
            var shownEmpty = self.classList.contains('is-empty');
            if ((cart.item_count === 0) !== shownEmpty || (cart.item_count > 0 && rows !== cart.items.length)) tpcRefresh();
          })
          .catch(function () {});
      };
    }
    tpcSync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tpcWatch); else tpcWatch();
  window.addEventListener('pageshow', function (e) { if (e.persisted) { tpcGoing = false; tpcRefresh(); } });

  // Keep the drawer footer clear of fixed bottom bars (Shopify preview bar).
  function tpcGap() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    var gap = 0;
    if (bar) {
      var r = bar.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight) gap = Math.max(0, window.innerHeight - r.top);
    }
    document.documentElement.style.setProperty('--tpc-bottom-gap', gap + 'px');
  }
  tpcGap();
  window.addEventListener('load', tpcGap);
  window.addEventListener('resize', tpcGap);
  setInterval(tpcGap, 2000);

  // Slider arrows: RTL track, so "next" scrolls toward the left.
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('[data-tpc-slide]');
    if (!arrow) return;
    e.preventDefault();
    var wrap = arrow.closest('[data-tpc-slider]');
    var track = wrap && wrap.querySelector('[data-tpc-track]');
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 10 : 150;
    var rtl = getComputedStyle(track).direction === 'rtl';
    var dir = arrow.getAttribute('data-tpc-slide') === 'next' ? 1 : -1;
    var delta = (rtl ? -1 : 1) * dir * step;
    var start = track.scrollLeft;
    track.scrollBy({ left: delta, behavior: 'smooth' });
    // Fallback where smooth scrolling is unavailable (reduced motion, some webviews).
    setTimeout(function () {
      if (track.scrollLeft === start) track.scrollLeft = start + delta;
    }, 400);
  });

  // Position counter ("2/4"): scroll events don't bubble, so listen in capture.
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.matches || !track.matches('[data-tpc-track]')) return;
    var wrap = track.closest('[data-tpc-slider]');
    var count = wrap && wrap.querySelector('[data-tpc-count]');
    if (!count || !track.clientWidth) return;
    var total = parseInt(count.getAttribute('data-total'), 10) || 1;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth;
    var idx = Math.min(total, Math.round(Math.abs(track.scrollLeft) / step) + 1);
    count.textContent = idx + '/' + total;
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tpc-cart-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-tpc-cart-add'), 10);
    if (!id) return;

    var drawer = document.querySelector('cart-drawer');
    var canDrawer = drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    var payload = { items: [{ id: id, quantity: 1 }] };
    if (canDrawer) {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }

    btn.disabled = true;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'error');
        if (canDrawer && res.body.sections) {
          var first = res.body.items && res.body.items[0];
          res.body.id = first ? first.variant_id : id;
          res.body.key = first ? first.key : undefined;
          drawer.classList.remove('is-empty');
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          drawer.renderContents(res.body);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        console.error('TROPICO cart add failed', err);
      });
  });
})();
